import Crud from '../views/EstablishmentType/Crud'
import Entity from '../views/EstablishmentType/Add'

let routes = {
    path: '/establishment_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/establishment_types/add',
            name: 'NewEstablishmentType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Estabelecimento',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Estabelecimento',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishment_types/edit/:id?',
            name: 'EditEstablishmentType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Estabelecimento',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Estabelecimento',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishment_types',
            name: 'list-establishment-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Estabelecimentos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Estabelecimentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
